module.exports = {
    defaultLocale: 'en',
    locales: ['en', 'fr', 'ar'],
    languageNames: {
        en: 'English',
        fr: 'Français',
        ar: 'عربي'
    }
}